import React, { useEffect, useRef, useState } from 'react'
import FormComponent from '../../../../../components/gernerateForm/FormComponent'
import { Grid, IconButton, InputAdornment, MenuItem, Typography } from '@mui/material';
import { ButtonOutlined, ButtonPrimary } from '../../../../../components/button/ButtonCustoms';
import { ReactComponent as Icon_upload } from '../../../../../assets/icons/upload-file.svg'
import { ReactComponent as AddSquare } from '../../../../../assets/icons/add-square-green.svg'
import { ReactComponent as Bag } from '../../../../../assets/icons/bag-button.svg'
import { ReactComponent as Document } from '../../../../../assets/icons/document.svg'
import InputTextField from '../../../../../components/input/inputTextField';
import InputDatePicker from '../../../../../components/input/inputDatePicker';
import moment from 'moment';
import { swalError } from '../../../../../components/alert/swal';
import FilterSelect from '../../../../../components/select/filterSelect';
import { MeetingTypeApi } from '../../../../../api/meeting-type/meeting-type.api';
import { MeetingRoomApi } from '../../../../../api/meeting-room/meeting-room.api';
import { useParams, useSearchParams } from 'react-router-dom';
import UploadFile from '../../../../../components/upload/UploadFile';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import { useTranslation } from 'react-i18next';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function MeetingDetail(props: any) {
  const { formMeetingRoom, setFormMeetingRoom } = props
  const { id } = useParams();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const [meetingType, setMeetingType] = useState<any[]>([])
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const [showPasswordC, setShowPasswordC] = React.useState(false);

  const handleClickShowPasswordC = () => setShowPassword((show) => !show);

  const handleMouseDownPasswordC = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleMouseUpPasswordC = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const getMeetingType = async () => {
    let condition: any = {
      page: 1,
      limit: 100,
      status: 'active'
    };

    const res = await MeetingTypeApi.list(condition);
    const data = res.data
    setMeetingType(data.data.items)
  }

  useEffect(() => {
    getMeetingType()
  }, [])
  const handleUpdate = async (type: string, file: any, index: number) => {

    const formData = new FormData();

    //DRAFT
    formData.append('file', file[0]);
    await MeetingRoomApi.uploadMeetingFile(formData, id).then((res: any) => {
      if (res.status < 300) {

        if (type === 'contents') {
          setFormMeetingRoom({
            ...formMeetingRoom, meeting_file_contents: formMeetingRoom?.meeting_file_contents?.map((item: any, i: number) => {
              return i === index ? res.data : item
            })
          })
        }
        if (type === 'agenda') {
          setFormMeetingRoom({
            ...formMeetingRoom, meeting_file_agenda: formMeetingRoom?.meeting_file_agenda?.map((item: any, i: number) => {
              return i === index ? res.data : item
            })
          })
        }
        if (type === 'other') {
          setFormMeetingRoom({
            ...formMeetingRoom, meeting_file_other: formMeetingRoom?.meeting_file_other?.map((item: any, i: number) => {
              return i === index ? res.data : item
            })
          })
        }

      }
    }).catch((error: any) => {
      console.log(error)
      swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
    })

  }
  return (
    <section className="w-full mt-10">
      <Grid container spacing={2}>
        {mode && <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px', width: "100%" }}>
            <Typography>{t("ลิงก์ออนไลน์")}</Typography>
            <div style={{
              border: "2px dotted #C1C3C7",
              borderRadius: "10px",
              padding: "15px 15px",
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <LinkOutlinedIcon sx={{ color: '#7e7e7e' }} />
                <Typography sx={{ cursor: 'pointer', textDecoration: 'underline', color: '#2186E3' }} onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  window.open(formMeetingRoom?.meeting_room_link, '_blank');

                }}>{formMeetingRoom?.meeting_room_link}</Typography>
              </div>

              <ButtonPrimary
                onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  navigator.clipboard.writeText(formMeetingRoom?.meeting_room_link);

                }}
                buttonName={t("คัดลอก")}
                btnProps={{
                  width: "150px",
                  bg: '#0F9F0C'
                }}
              />
            </div>

          </div>
        </Grid>}
        <Grid
          item
          xs={12}
          md={12}
          lg={6}
          sx={{
            alignSelf: "end",
          }}
        >
          <FilterSelect
            // value={inputValueSearch.year ?? ""}
            heading={t('MEETING.MEETING_TYPE')}
            labelId="year-id"
            selectId="year-select-id"
            options={meetingType.map((item: any, index: number) => (
              <MenuItem value={item.id_meeting_type} key={index + 1}>
                {item.meeting_type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, id_meeting_type: e.target.value })
            }}
            value={formMeetingRoom?.id_meeting_type || ''}
            disabled={mode ? true : false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={6}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t('MEETING.MEETING_NAME')}
            placeholder={t('MEETING.MEETING_NAME')}
            value={formMeetingRoom?.meeting_room_name}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_name: e.target.value })
            }
            }
            helperText={
              ""
            }
            disabled={mode ? true : false}

          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputDatePicker
            heading={t('MEETING.MEETING_DATE')}
            placeholder={t('MEETING.MEETING_DATE')}
            value={formMeetingRoom?.meeting_room_start_date || ''}
            onChange={(e: any) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_start_date: moment(e).format('yyyy-MM-DD'), meeting_room_end_date: moment(e).format('yyyy-MM-DD') })
            }}
            helperText={
              ""
            }
            disabled={mode ? true : false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          sx={{
            alignSelf: "end",
          }}
        >
          {/* <InputDatePicker
            heading={'เวลาเริ่มต้น'}
            placeholder={'เวลาเริ่มต้น'}
            value={formMeetingRoom?.meeting_room_end_date || undefined}
            onChange={(e: any) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_end_date: moment(e).format('yyyy-mm-DD') })
            }}
            helperText={
              ""
            }
            disabled={false}
          /> */}
          <InputTextField
            heading={t('MEETING.START_TIME')}
            placeholder={t('MEETING.START_TIME')}
            value={formMeetingRoom?.meeting_room_start_time || ''}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log(e.target.value);
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_start_time: e.target.value })
            }
            }
            helperText={
              ""
            }
            type='time'
            disabled={mode ? true : false}

          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={4}
          sx={{
            alignSelf: "end",
          }}
        >
          {/* <InputDatePicker
            heading={'เวลาสิ้นสุดการประชุม'}
            placeholder={'วันที่สิ้นสุดการประชุม'}
            value={formMeetingRoom?.meeting_room_end_date || undefined}
            onChange={(e: any) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_end_date: moment(e).format('yyyy-mm-DD') })
            }}
            helperText={
              ""
            }
            disabled={false}
          /> */}
          <InputTextField
            heading={t('MEETING.END_TIME')}
            placeholder={t('MEETING.END_TIME')}
            value={formMeetingRoom?.meeting_room_end_time || ''}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_end_time: e.target.value })
            }
            }
            helperText={
              ""
            }
            type='time'
            disabled={mode ? true : false}

          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t('MEETING_CATEGORY.DETAILS')}
            placeholder={t('MEETING_CATEGORY.DETAILS')}
            value={formMeetingRoom?.meeting_room_desc}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_desc: e.target.value })
            }
            }
            helperText={
              ""
            }
            disabled={mode ? true : false}
            row={3}
            maxRows={5}
            disablePaddingMultiline
            multiline
            inputHeight={"auto"}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          lg={mode ? 12 : 6}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t('MEETING.MEETING_ROOM_PASSWORD')}
            placeholder={t('MEETING.MEETING_ROOM_PASSWORD')}
            value={formMeetingRoom?.meeting_room_password}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_password: e.target.value })
            }
            }
            helperText={
              ""
            }
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? 'hide the password' : 'display the password'
                  }
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            disabled={mode ? true : false}

          />
        </Grid>
        {!mode && <Grid
          item
          xs={12}
          md={12}
          lg={6}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t('MEETING.CONFIRM_MEETING_ROOM_PASSWORD')}
            placeholder={t('MEETING.CONFIRM_MEETING_ROOM_PASSWORD')}
            value={formMeetingRoom?.meeting_room_password_check}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_password_check: e.target.value })
            }
            }
            onblur={(e: any) => {
              if (e.target.value !== formMeetingRoom?.meeting_room_password) {
                swalError(t('MEETING.PASSWORD_MISMATCH'))
              }
            }}
            helperText={
              ""
            }
            disabled={mode ? true : false}
            type={showPasswordC ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPasswordC ? 'hide the password' : 'display the password'
                  }
                  onClick={handleClickShowPasswordC}
                  onMouseDown={handleMouseDownPasswordC}
                  onMouseUp={handleMouseUpPasswordC}
                  edge="end"
                >
                  {showPasswordC ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          // type='password'
          />
        </Grid>}
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <InputTextField
            heading={t('MEETING.MEETING_LOCATION_INFO')}
            placeholder={t('MEETING.MEETING_LOCATION_INFO')}
            value={formMeetingRoom?.meeting_room_location}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_room_location: e.target.value })

            }
            }
            helperText={
              ""
            }
            disabled={mode ? true : false}
          />
        </Grid>
        {mode ? <Grid
          item
          xs={12}
          md={12}
          lg={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px', width: "100%" }}>
            <Typography>{t("ลิงก์ออนไลน์")}</Typography>
            <div style={{
              border: "2px dotted #C1C3C7",
              borderRadius: "10px",
              padding: "15px 15px",
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <LinkOutlinedIcon sx={{ color: '#7e7e7e' }} />
                <Typography sx={{ cursor: 'pointer', textDecoration: 'underline', color: '#2186E3' }} onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  window.open(formMeetingRoom?.meeting_room_link, '_blank');

                }}>{formMeetingRoom?.meeting_room_link}</Typography>
              </div>

              <ButtonPrimary
                onClick={() => {
                  // handleSubmit(inputValueFormStudent.information);
                  navigator.clipboard.writeText(formMeetingRoom?.meeting_room_link);

                }}
                buttonName={t("คัดลอก")}
                btnProps={{
                  width: "150px",
                  bg: '#0F9F0C'
                }}
              />
            </div>

          </div>
        </Grid> :
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{
              alignSelf: "end",
            }}
          >
            <InputTextField
              heading={t('MEETING.ONLINE_MEETING_LINK')}
              placeholder={t('MEETING.ONLINE_MEETING_LINK')}
              value={formMeetingRoom?.meeting_room_link}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFormMeetingRoom({ ...formMeetingRoom, meeting_room_link: e.target.value })
              }
              }
              helperText={
                ""
              }
              disabled={false}
            />
          </Grid>}
      </Grid>


      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
        <Typography variant='h6'>{t('MEETING.MEETING_CONTENTS')}</Typography>
        {!mode && <AddSquare onClick={() => setFormMeetingRoom({ ...formMeetingRoom, meeting_file_contents: formMeetingRoom?.meeting_file_contents?.length > 0 ? [...formMeetingRoom?.meeting_file_contents, {}] : [{}] })} />}

      </div>
      {formMeetingRoom?.meeting_file_contents?.map((item: any, index: number) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

            {item?.file_name ?
              <div style={{
                border: "2px dotted #C1C3C7",
                borderRadius: "10px",
                padding: "15px 15px",
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%'
              }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Document />
                  <div style={{ display: "flex", alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                    {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                  </div>
                </div>

                <ButtonOutlined
                  onClick={() => {
                    // handleSubmit(inputValueFormStudent.information);
                    window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                  }}
                  buttonName={t('MEETING.DOWNLOAD_FILE')}
                  btnProps={{
                    width: "150px",
                    // border: '#0F9F0C'
                  }}
                />
              </div> :
              <UploadFile
                onDrop={(file) => {
                  handleUpdate('contents', file, index);
                }}
                // enableFormatImage
                onDeleteFile={() => {
                  // setFile(null);
                }}
                noClick={false}
              // formatText='ขนาดไม่เกิน 10MB'
              // customFormat={["image/jpeg", "image/jpg", "image/png"]}

              />}
            {!mode && <div style={{
              border: '1px solid #DDE1EB',
              borderRadius: '8px',
              padding: '16px',
            }}>
              <Bag />
            </div>}
          </div>
        )
      })}


      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
        <Typography variant='h6'>{t('MEETING.MEETING_AGENDA')}</Typography>
        {!mode && <AddSquare onClick={() => setFormMeetingRoom({ ...formMeetingRoom, meeting_file_agenda: formMeetingRoom?.meeting_file_agenda?.length > 0 ? [...formMeetingRoom?.meeting_file_agenda, {}] : [{}] })} />}

      </div>
      {formMeetingRoom?.meeting_file_agenda?.map((item: any, index: number) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

            {item?.file_name ?
              <div style={{
                border: "2px dotted #C1C3C7",
                borderRadius: "10px",
                padding: "15px 15px",
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%'
              }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Document />
                  <div style={{ display: "flex", alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                    {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                  </div>
                </div>

                <ButtonOutlined
                  onClick={() => {
                    // handleSubmit(inputValueFormStudent.information);
                    window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');

                  }}
                  buttonName={t('MEETING.DOWNLOAD_FILE')}
                  btnProps={{
                    width: "150px",
                    // border: '#0F9F0C'
                  }}
                />
              </div> :
              <UploadFile
                onDrop={(file) => {
                  handleUpdate('agenda', file, index);
                }}
                // enableFormatImage
                onDeleteFile={() => {
                  // setFile(null);
                }}
                noClick={false}
              // formatText='ขนาดไม่เกิน 10MB'
              // customFormat={["image/jpeg", "image/jpg", "image/png"]}

              />}
            {!mode && <div style={{
              border: '1px solid #DDE1EB',
              borderRadius: '8px',
              padding: '16px',
            }} onClick={() => {
              setFormMeetingRoom({ ...formMeetingRoom, meeting_file_agenda: formMeetingRoom?.meeting_file_agenda.filter((x: any) => x.id_meeting_room_file !== item?.id_meeting_room_file) })
            }}>
              <Bag />
            </div>}
          </div>
        )
      })}


      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
        <Typography variant='h6'>{t('MEETING.ATTACH_ADDITIONAL_DOCUMENTS')}</Typography>
        {!mode && <AddSquare onClick={() => setFormMeetingRoom({ ...formMeetingRoom, meeting_file_other: formMeetingRoom?.meeting_file_other?.length > 0 ? [...formMeetingRoom?.meeting_file_other, {}] : [{}] })} />}
      </div>
      {formMeetingRoom?.meeting_file_other?.map((item: any, index: number) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

            {item?.file_name ?
              <div style={{
                border: "2px dotted #C1C3C7",
                borderRadius: "10px",
                padding: "15px 15px",
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%'
              }}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Document />
                  <div style={{ display: "flex", alignItems: 'center' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                    {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                  </div>
                </div>

                <ButtonOutlined
                  onClick={() => {
                    // handleSubmit(inputValueFormStudent.information);
                    window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');

                  }}
                  buttonName={t('MEETING.DOWNLOAD_FILE')}
                  btnProps={{
                    width: "150px",
                    // border: '#0F9F0C'
                  }}
                />
              </div> :
              <UploadFile
                onDrop={(file) => {
                  handleUpdate('other', file, index);
                }}
                // enableFormatImage
                onDeleteFile={() => {
                  // setFile(null);
                }}
                noClick={false}
              // formatText='ขนาดไม่เกิน 10MB'
              // customFormat={["image/jpeg", "image/jpg", "image/png"]}

              />}
            {!mode && <div style={{
              border: '1px solid #DDE1EB',
              borderRadius: '8px',
              padding: '16px',
            }}>
              <Bag />
            </div>}
          </div>
        )
      })}

      {/* <ButtonOutlined
          onClick={() => {
            // handleSubmit(inputValueFormStudent.information);
          }}
          buttonName="ลบ"
          btnProps={{
            width: "100px",
          }}
        /> */}

    </section>
  )
}
